import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import uuid from 'uuid';
import { TableBody, TableRow, TableCell, useTheme, Tooltip } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import utils from 'src/utils/utils';
import MassActionItemMenu from './MassActionItemMenu';

import columnConfig from './utils';
import { useAlert } from 'src/hooks';

function MassActionListTableRows({ massActionList, getOptions, actions }) {
  const theme = useTheme();
  const { showAlert } = useAlert();
  const { t } = useTranslation();
  return (
    <TransitionGroup component={TableBody}>
      {massActionList.map(massAction => (
        <CSSTransition timeout={300} classNames="fade" key={massAction.id || uuid()}>
          <TableRow
            key={massAction.id || uuid()}
            hover
            onDoubleClick={e => {
              e.preventDefault();
              actions.edit(massAction);
            }}
          >
            <TableCell>
              <MassActionItemMenu
                request={massAction}
                options={getOptions(massAction)}
                actions={{
                  edit: () => actions.edit(massAction),
                  execute: () => actions.execute(massAction),
                  enable: () => actions.enable(massAction, showAlert),
                  disable: () => actions.disable(massAction, showAlert),
                  showHistory: () => actions.showHistory(massAction),
                }}
              />
            </TableCell>
            <TableCell align="left" padding="none" scope="row" style={{ fontWeight: 'bold' }}>
              <div style={{ display: 'flex' }}>
                {!!massAction.duplicates.length && (
                  <div style={{ display: 'flex', alignItems: 'center', margin: '2px' }}>
                    <Tooltip title={t('smartmessaging.campaignAction.duplicateWarning')}>
                      <WarningIcon color="error" />
                    </Tooltip>
                  </div>
                )}
                <div style={{ display: 'flex', alignItems: 'center', margin: '2px' }}>
                  {massAction.name}
                </div>
              </div>
            </TableCell>
            {columnConfig.columnNames
              .filter(
                n =>
                  n !== 'name' &&
                  (utils.isNodeMapped() ? true : ['networkNodeName'].indexOf(n) === -1)
              )
              .map(columnName => (
                <TableCell
                  align="left"
                  padding="none"
                  style={{ color: theme.palette.text.secondary }}
                  key={columnName}
                >
                  {columnConfig.renderCell(columnName, massAction)}
                </TableCell>
              ))}
          </TableRow>
        </CSSTransition>
      ))}
    </TransitionGroup>
  );
}

MassActionListTableRows.propTypes = {
  massActionList: PropTypes.array.isRequired,
  getOptions: PropTypes.func.isRequired,
  actions: PropTypes.object.isRequired,
};

export default MassActionListTableRows;
